import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CreateAgentTokenRequest, PatCreatedResponse, PatDTO } from '../models/pat.model';

/** Access tokens of agent accounts, managed by the platform admin (NEX-1980). */
@Injectable({ providedIn: 'root' })
export class AgentTokenService {
  private readonly http = inject(HttpClient);

  getTokenScopes(customerId: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.agentsUrl(customerId)}/token-scopes`);
  }

  listTokens(customerId: string, userId: string): Observable<PatDTO[]> {
    return this.http.get<PatDTO[]>(this.tokensUrl(customerId, userId));
  }

  createToken(customerId: string, userId: string, request: CreateAgentTokenRequest): Observable<PatCreatedResponse> {
    return this.http.post<PatCreatedResponse>(this.tokensUrl(customerId, userId), request);
  }

  revokeToken(customerId: string, userId: string, tokenId: string): Observable<void> {
    return this.http.delete<void>(`${this.tokensUrl(customerId, userId)}/${tokenId}`);
  }

  private agentsUrl(customerId: string): string {
    return `${environment.apiBaseUrl}/api/v1/customers/${customerId}/agents`;
  }

  private tokensUrl(customerId: string, userId: string): string {
    return `${this.agentsUrl(customerId)}/${userId}/tokens`;
  }
}
